import List from '@mui/material/List';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { EMenuItemType, IMenuItem } from '../types';
import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuSection } from './SidebarMenuSection';

export const SidebarMenu = ({ menu }: { menu: IMenuItem[] }) => {
  const { pathname } = useLocation();

  const [expanded, setExpanded] = useState('');

  const isExpanded = (route: string) => route === expanded;

  useEffect(() => {
    const [_, sectionName] = pathname.split('/');
    const sectionRoute = `/${sectionName}`;

    if (expanded !== sectionRoute) {
      setExpanded(prevState => prevState === sectionRoute ? '' : sectionRoute);
    }
  }, [pathname]);

  return (
    <List>
      {menu.map((section) => section.menuItemType === EMenuItemType.Header ? (
        <SidebarMenuSection
          key={section.id}
          title={section.text}
        />
      ) : (
        <SidebarMenuItem
          key={section.id}
          item={section}
          expanded={isExpanded(section.link)}
          toggleExpand={() => setExpanded(prevState => prevState === section?.link ? '' : section?.link)}
        />
      ))}
    </List>
  );
};
